// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const armarouge: PokeData = {
  "id": 936,
  "name": "armarouge",
  "height": 15,
  "weight": 850,
  "base_experience": 263,
  "types": [
    PokeType.FIRE,
    PokeType.PSYCHIC
  ],
  "api_moves": [
    "leer",
    "ember",
    "flamethrower",
    "fire-spin",
    "night-shade",
    "will-o-wisp",
    "astonish",
    "calm-mind",
    "lava-plume",
    "wide-guard",
    "psyshock",
    "flame-charge",
    "clear-smog",
    "ally-switch",
    "incinerate",
    "mystical-fire",
    "expanding-force",
    "armor-cannon"
  ],
  "moves": [
    "leer",
    "ember",
    "flamethrower",
    "fire-spin",
    "night-shade",
    "calm-mind",
    "future-sight",
    "psywave",
    "psychic-fangs",
    "blaze-kick",
    "kinesis",
    "psy-ball",
    "morning-sun"
  ],
  "evolution_chain": {
    "id": 490,
    "item": null,
    "species": [
      {
        "name": "charcadet",
        "order": 1003,
        "types": [
          PokeType.FIRE
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "armarouge",
        "order": 1004,
        "types": [
          PokeType.FIRE,
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": 935,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": {
              "name": "auspicious-armor"
            },
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.USE_ITEM
            },
            "gender": null
          }
        ]
      },
      {
        "name": "ceruledge",
        "order": 1005,
        "types": [
          PokeType.FIRE,
          PokeType.GHOST
        ],
        "evolves_from_species_id": 935,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": {
              "name": "malicious-armor"
            },
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.USE_ITEM
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 122,
    "speed": 104,
    "ability_power": 174
  },
  "stat_changes": [],
  "catch_rate": 25,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
